<script lang="ts">
	import type { Snippet } from 'svelte';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import ModalDialog from '$lib/components/modals/ModalDialog.svelte';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import * as m from '$paraglide/messages';

	interface Props {
		children?: Snippet;
	}

	const { children }: Props = $props();

	let open = $state(false);
	// the 2 elements below are used to get a reference to the button so that we can position the modal
	let wrapper: HTMLElement | undefined = $state();
	const button: HTMLElement | undefined = $derived(wrapper?.children[0] as HTMLElement);
	// wrapper always has a child after mount
	const modalHeightOffset = $derived(button ? -2 * button.offsetHeight - 8 : 0); // move the modal up 2 button heights and 1 gap

	function showSettingsModal() {
		open = true;
		track({
			action: 'settings',
		});
	}

	function closeModal() {
		open = false;
	}
</script>

<div style="display:contents" bind:this={wrapper}>
	<Button
		ariaLabel={m.map_controls__aria_labels__settings()}
		variant="filled"
		color="white"
		size="sm"
		icon="layers"
		onclick={showSettingsModal}
	/>
</div>

<ModalDialog
	bind:open
	relativeTo={button}
	relativeHeightOffset={modalHeightOffset}
	closeText={m.settings__close()}
	closeCallback={closeModal}
>
	<div class="w-100 max-w-full flex flex-col gap-2" data-testid="map-settings-modal">
		{@render children?.()}
	</div>
</ModalDialog>
